// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled from 'styled-components';

export const HeaderWrapper = styled.div<{ isMenuOpen: boolean }>`
  transition: ${props => (props.isMenuOpen ? 'none' : 'all 0.3s ease 0s')};
`;
